const translations = {
  followthecourse: {
    en: 'Follow the course',
    de: 'Folgen Sie dem Straßenverlauf'
  },
  nodatareceived: {
    en: 'Position cannot be determined',
    de: 'Position kann zur Zeit nicht bestimmt werden'
  },
  artakkfemale: {
    en: 'the',
    de: 'die'
  },
  artakkmale: {
    en: 'the',
    de: 'den'
  },
  artakkneutral: {
    en: 'the',
    de: 'das'
  },
  artunknown: {
    en: 'the',
    de: ''
  },
  now: {
    en: 'Now',
    de: 'Jetzt'
  },
  turnlsoft: {
    en: 'turn soft left',
    de: 'halb links abbiegen'
  },
  turnrsoft: {
    en: 'turn soft right',
    de: 'halb rechts abbiegen'
  },
  turnlsharp: {
    en: 'turn hard left',
    de: 'scharf links abbiegen'
  },
  turnrsharp: {
    en: 'turn hard right',
    de: 'scharf rechts abbiegen'
  },
  turnl: {
    en: 'turn left',
    de: 'links abbiegen'
  },
  turnr: {
    en: 'turn right',
    de: 'rechts abbiegen'
  },
  straight: {
    en: 'drive straight',
    de: 'gerade aus fahren'
  },
  'meters+': {
    en: 'meters',
    de: 'Metern'
  },
  followthisstreet: {
    en: 'Follow this road for',
    de: 'Folgen Sie dieser Straße noch'
  },
  endofstreet: {
    en: 'At the end of the road',
    de: 'Am Ende der Straße'
  },
  then: {
    en: ', then',
    de: ', dann'
  },
  uturn: {
    en: 'If possible please make a legal uturn',
    de: 'Bitte wenden'
  },
  reacheddestination: {
    en: 'you have reached your destination',
    de: 'haben Sie Ihr Ziel erreicht'
  },
  rbintro: {
    en: 'Exit roundabout at the',
    de: 'Nehmen Sie im Kreisverkehr die'
  },
  exit: {
    en: 'exit',
    de: 'Ausfahrt'
  },
  '1th': {
    en: '1st',
    de: 'erste'
  },
  '2th': {
    en: '2nd',
    de: 'zweite'
  },
  '3th': {
    en: '3rd',
    de: 'dritte'
  },
  '4th': {
    en: '4th',
    de: 'vierte'
  },
  '5th': {
    en: '5th',
    de: 'fünfte'
  },
  '6th': {
    en: '6th',
    de: 'sechste'
  },
  '7th': {
    en: '7th',
    de: 'siebte'
  },
  '8th': {
    en: '8th',
    de: 'achte'
  },
  '9th': {
    en: '9th',
    de: 'neunte'
  },
  '10th': {
    en: '10th',
    de: 'zehnte'
  },
  stayl: {
    en: 'stay left',
    de: 'halten sie sich links'
  },
  stayr: {
    en: 'stay right',
    de: 'halten sie sich rechts'
  },
  leaver: {
    en: 'exit right',
    de: 'rechts abfahren'
  },
  leavel: {
    en: 'exit left',
    de: 'links abfahren'
  },
  '1dat': {
    en: 'one',
    de: 'einem'
  },
  taketheferry: {
    en: 'take the ferry',
    de: 'nehmen Sie die Fähre'
  },
  trafficjam1: {
    en: 'Your route is being recalculated, using up to date trafic information',
    de: 'Die Route wird aufgrund aktueller Verkehrsmeldungen neu berechnet'
  },
  verylong: {
    en: 'a while',
    de: 'sehr lange'
  },
  'drive;to': {
    en: ', Drive to',
    de: ', Fahren Sie in Richtung'
  },
  drive: {
    en: ', Drive',
    de: ', Fahren Sie'
  },
  ';into': {
    en: ';into',
    de: ';in'
  },
  ';onto': {
    en: ';onto',
    de: ';auf'
  },
  'destination;is;right': {
    en: ', Your destination is on the right side',
    de: ', Das Ziel ligt auf der rechten Seite'
  },
  'destination;is;left': {
    en: ', Your destination is on the left side',
    de: ', Das Ziel ligt auf der linken Seite'
  },
  takethe: {
    en: 'Take the',
    de: 'Nehmen Sie die'
  },
  ';kms+': {
    en: ';kilometers',
    de: ';Kilometern'
  },
  ';kms': {
    en: ';kilometers',
    de: ';Kilometern'
  },
  ';km+': {
    en: ';kilometer',
    de: ';Kilometer'
  },
  ';km': {
    en: ';kilometer',
    de: ';Kilometer'
  },
  ', a': {
    en: '. a',
    de: ''
  },
  ';miles+': {
    en: ';Miles',
    de: ';Meilen'
  },
  ';mile+': {
    en: ';Miles',
    de: ';Meilen'
  },
  '0;point': {
    en: 'Point',
    de: 'Null Komma'
  },
  'str.': {
    en: 'street',
    de: 'Straße'
  },
  street: {
    en: 'street',
    de: 'Straße'
  },
  offroad: {
    en: 'offroad',
    de: 'offroad'
  },
  na: {
    en: '',
    de: ''
  }
};

export default class InstructionsTranslations {
  getByTextAndLanguage(text, language) {
    if (text in translations && language in translations[text]) {
      return translations[text][language];
    }

    if (text in translations && 'en' in translations[text]) {
      return translations[text].en;
    }

    return text;
  }
}

module.exports = InstructionsTranslations;
